// Catálogo del VisionLauncher (el "menú"). Cada ítem es una tile del launcher/dock.
import {
  Activity, BookOpen, Brain, ClipboardList, Flame, KeyRound, LayoutDashboard,
  ScrollText, Search, Settings2, ShieldCheck, Siren, Stethoscope, Trophy, type LucideIcon,
} from "lucide-react";

export interface LauncherItem {
  icon: LucideIcon;
  label: string;
  description?: string;
  /** Ruta interna del shell. Mutuamente excluyente con `action`. */
  path?: string;
  /** Acción especial (ej. abrir el módulo triage full-page). */
  action?: "triage";
  color: string;
  gradient: [string, string];
  teacherOnly?: boolean;
  /** Solo visible para institution_admin / platform_admin. */
  adminOnly?: boolean;
}

export const CATALOG: LauncherItem[] = [
  { icon: Stethoscope, label: "Biblioteca", description: "Casos clínicos", path: "/app/cases", color: "#2563EB", gradient: ["#2563EB", "#1d4ed8"] },
  { icon: Activity, label: "Mis pacientes", description: "Seguimiento longitudinal", path: "/app/active", color: "#0ea5e9", gradient: ["#0ea5e9", "#0369a1"] },
  { icon: Siren, label: "Urgencia · Triage 3D", description: "Simulador inmersivo", action: "triage", color: "#ef4444", gradient: ["#f43f5e", "#b91c1c"] },
  { icon: Brain, label: "Mapa cognitivo", description: "Mastery y misconceptions", path: "/app/cognitive", color: "#8b5cf6", gradient: ["#8b5cf6", "#6d28d9"] },
  { icon: Flame, label: "Flashcards", description: "Repaso espaciado", path: "/app/srs", color: "#f97316", gradient: ["#f97316", "#c2410c"] },
  { icon: ClipboardList, label: "Preguntas MCQ", description: "Banco de preguntas", path: "/app/mcq", color: "#14b8a6", gradient: ["#14b8a6", "#0f766e"] },
  { icon: Search, label: "Evidencia", description: "Búsqueda semántica", path: "/app/evidence", color: "#22c55e", gradient: ["#22c55e", "#15803d"] },
  { icon: ShieldCheck, label: "Anatomía 3D", description: "Atlas interactivo", path: "/app/anatomy", color: "#06b6d4", gradient: ["#06b6d4", "#0e7490"] },
  { icon: ScrollText, label: "Viva voce", description: "Defensa del caso", path: "/app/viva", color: "#d4a843", gradient: ["#d4a843", "#a16207"] },
  { icon: Trophy, label: "Logros", description: "Ranking y achievements", path: "/app/achievements", color: "#eab308", gradient: ["#eab308", "#a16207"] },
  { icon: LayoutDashboard, label: "Dashboard docente", description: "Analítica del curso", path: "/app/teacher", color: "#10b981", gradient: ["#10b981", "#0d9488"], teacherOnly: true },
  { icon: BookOpen, label: "Crear caso", description: "Generador de casos", path: "/app/teacher/case-builder", color: "#34d399", gradient: ["#34d399", "#059669"], teacherOnly: true },
  { icon: Settings2, label: "Administración", description: "Usuarios e instituciones", path: "/app/admin", color: "#3b82f6", gradient: ["#3b82f6", "#334155"], adminOnly: true },
  { icon: KeyRound, label: "Seguridad", description: "2FA y cuenta", path: "/app/settings/security", color: "#64748b", gradient: ["#94a3b8", "#475569"] },
];
